import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <main id="main-content" className="bg-[#0a0a0a] text-white min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="font-display text-[120px] font-black text-[#FF6B00] leading-none">
          404
        </div>
        <h1 className="font-display text-4xl font-bold uppercase tracking-tight">
          Out of Bounds
        </h1>
        <p className="mt-4 text-white/60">
          The page you&apos;re looking for hit the net. Let&apos;s get you back in play.
        </p>
        <Link
          to="/"
          data-testid="notfound-home"
          className="mt-8 inline-flex items-center bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-sm px-7 py-4"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
